import { tokens } from "shared/components/Spor";
import styled, { css } from "styled-components";

const gridIconColumnWidth = tokens.default.size.spacing[3];
const gridTimeColumnWidth = "94px";
const gridColumnGap = tokens.default.size.spacing[1.5];
const gridHorizontalPadding = tokens.default.size.spacing[3];

const busStopGridRowLayout = css`
  display: grid;
  grid-template-columns:
    ${gridIconColumnWidth} minmax(0, 1fr)
    ${gridTimeColumnWidth} ${gridTimeColumnWidth};
  column-gap: ${gridColumnGap};
  min-width: 0;
`;

export const BusStopGrid = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

export const BusStopGridRow = styled.div<{ $isCurrentStop?: boolean }>`
  ${busStopGridRowLayout}
  padding: 16px ${gridHorizontalPadding};
  background-color: ${({ $isCurrentStop, theme }) =>
    $isCurrentStop ? theme.colorSelected : undefined};
`;

export const BusStopGridHeader = styled.div`
  ${busStopGridRowLayout}
  padding: ${tokens.default.size.spacing[1]}
    ${gridHorizontalPadding};
  background-color: ${({ theme }) => theme.colorOutlineCore};
`;

export const BusStopGridBody = styled.div`
  > ${BusStopGridRow}:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  }
`;

export const BusStopGridCell = styled.div`
  min-width: 0;
`;
